import { Box, BoxProps } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import classes from './articleContent.module.scss';

import { EnvironmentService } from '@/services/EnvironmentService';

type ArticleProps = {
    content: string;
    styles?: BoxProps;
};

function ArticleContent(props: ArticleProps) {
    const { content, styles } = props;
    const [src, setSrc] = useState(content);

    useEffect(() => {
        const changeSrc = content.replaceAll(
            '/uploads/',
            `${EnvironmentService.getStrapiImageURL()}/uploads/`
        );

        setSrc(changeSrc);
    }, [content]);

    return (
        <Box
            {...styles}
            className={classes.article}
            dangerouslySetInnerHTML={{
                __html: src
            }}
        />
    );
}

export default ArticleContent;
